import { useCallback, useContext } from "react";
import { OpenAPI } from "../services";
import { AuthContext } from "../context/authContext";
import { toast } from "react-toastify";

export const useApiService = () => {
  const token = localStorage.getItem("token");
  // console.log("Token", token);
  if (token) {
    OpenAPI.TOKEN = token;
  }
  const { logout } = useContext(AuthContext);
  // console.log("Open API", OpenAPI);
  /**
   * Handle API Request
   * @param requestPromise - The promise returned from the API request
   * @returns A Promise that resolves to the data returned from the API
   */
  const handleRequest = useCallback(
    async <T>(requestPromise: Promise<T>): Promise<T | undefined> => {
      try {
        const response = await requestPromise;
        return response;
      } catch (error: any) {
        console.log(error?.body?.error);
        if (error?.body?.error.message === "Failed to authenticate token.") {
          toast.error("Session expired. Please log in again.");
          logout();
        }
        console.error("API Request Error:", error?.body?.error.statusCode);
        throw error;
      }
    },
    []
  );

  return {
    handleRequest,
  };
};
